import posthog from 'posthog-js';

const configJson = document.getElementById('posthog-config')?.textContent;
const config = JSON.parse(configJson || '{}');

if (config.api_key) {
    posthog.init(config.api_key, {
        api_host: config.host,
        person_profiles: 'identified_only',
    });

    const userJson = document.getElementById('user')?.textContent;
    const user = JSON.parse(userJson || '{}');
    if (user.id) {
        posthog.identify(String(user.id));
    }
}
